module.exports = __webpack_public_path__ + "img/IMG_2238.48cffb35.jpg";